import React from 'react'
import Breadcrumb from '../components/Breadcrumbs'
import { Link } from 'react-router-dom'

function SmartCards() {
    return (
        <div>
            <Breadcrumb title="Smart Cards" subtitle="Smart Cards" />
            
            <section className="service-grid-area pt-120 pb-90">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-xl-12">
                            <div className="section-title text-center mb-50">
                                <h6 className="subtitle">Technology & Security</h6>
                                <h2 className="title">Advanced Smart Card Technology</h2>
                                <p>From basic magnetic stripes to advanced contactless chips, we supply cards that power your security and access control systems.</p>
                            </div>
                        </div>
                    </div>

                    <div className="row gy-4">
                        {/* RFID / Proximity */}
                        <div className="col-xl-3 col-lg-4 col-md-6">
                            <div className="catalog-card mb-30 wow fadeInUp animated" data-wow-delay=".3s">
                                <div className="catalog-card-img">
                                    <img src="assets/imgs/smart cards/rfid.png" alt="RFID Proximity Cards" />
                                </div>
                                <div className="catalog-card-content">
                                    <h4><Link to="/contact?interest=RFID+Cards">RFID / Proximity</Link></h4>
                                    <p>125 KHz cards compatible with most standard access control readers.</p>
                                    <Link to="/contact?interest=RFID+Cards" className="more-btn">Get Quote <i className="fa-solid fa-arrow-right"></i></Link>
                                </div>
                            </div>
                        </div>

                        {/* Mifare / NFC */}
                        <div className="col-xl-3 col-lg-4 col-md-6">
                            <div className="catalog-card mb-30 wow fadeInUp animated" data-wow-delay=".5s">
                                <div className="catalog-card-img">
                                    <img src="assets/imgs/smart cards/nfc.png" alt="Mifare NFC Cards" />
                                </div>
                                <div className="catalog-card-content">
                                    <h4><Link to="/contact?interest=Mifare+NFC+Cards">Mifare / NFC</Link></h4>
                                    <p>13.56 MHz contactless smart cards (1K, 4K) for secure transactions and access.</p>
                                     <Link to="/contact?interest=Mifare+NFC+Cards" className="more-btn">Get Quote <i className="fa-solid fa-arrow-right"></i></Link>
                                </div>
                            </div>
                        </div>

                         {/* Metal Cards */}
                         <div className="col-xl-3 col-lg-4 col-md-6">
                            <div className="catalog-card mb-30 wow fadeInUp animated" data-wow-delay=".7s">
                                <div className="catalog-card-img">
                                    <img src="assets/imgs/smart cards/metal.png" alt="Metal Cards" />
                                </div>
                                <div className="catalog-card-content">
                                    <h4><Link to="/contact?interest=Metal+Cards">Metal Cards</Link></h4>
                                    <p>Premium metal business and membership cards for an exclusive look and feel.</p>
                                     <Link to="/contact?interest=Metal+Cards" className="more-btn">Get Quote <i className="fa-solid fa-arrow-right"></i></Link>
                                </div>
                            </div>
                        </div>

                         {/* Plain PVC */}
                         <div className="col-xl-3 col-lg-4 col-md-6">
                            <div className="catalog-card mb-30 wow fadeInUp animated" data-wow-delay=".9s">
                                <div className="catalog-card-img">
                                    <img src="assets/imgs/smart cards/pvc.png" alt="Plain PVC Cards" />
                                </div>
                                <div className="catalog-card-content">
                                    <h4><Link to="/contact?interest=Plain+PVC+Cards">Plain PVC Cards</Link></h4>
                                    <p>High-quality blank white PVC cards suitable for all ID card printers.</p>
                                     <Link to="/contact?interest=Plain+PVC+Cards" className="more-btn">Get Quote <i className="fa-solid fa-arrow-right"></i></Link>
                                </div>
                            </div>
                        </div>

                    </div>
                    
                    <div className="row mt-60">
                         <div className="col-xl-12">
                             <div className="cta-item-2 text-center mb-30" style={{backgroundColor: 'rgba(74, 163, 223, 0.1)'}}>
                                 <h3 className="title" style={{color: '#173c5d'}}>Need Custom Encoding or Pre-printing?</h3>
                                 <p style={{color: '#173c5d'}} className="mb-20">We offer pre-printed offset cards and custom chip encoding services for bulk orders.</p>
                                 <Link to="/contact?interest=Custom+Encoding" className="rr-btn">Contact Our Experts</Link>
                             </div>
                         </div>
                    </div>

                </div>
            </section>
        </div>
    )
}

export default SmartCards
